import { FC } from 'react';
import type { DatePreset } from './types';

interface Props {
  presets: DatePreset[];
  selectedPreset: string | null;
  onPresetClick: (preset: DatePreset) => void;
}

export const PresetList: FC<Props> = ({
  presets,
  selectedPreset,
  onPresetClick,
}) => {
  return (
    <div className="space-y-2">
      {presets.map((preset) => {
        const isSelected = selectedPreset === preset.id;

        return (
          <label
            key={preset.id}
            className="hover:bg-onlight-bg-2 dark:hover:bg-ondark-bg-2 flex cursor-pointer items-center gap-3 rounded-lg px-3 py-1.5"
            onClick={() => onPresetClick(preset)}
          >
            <input
              type="radio"
              checked={isSelected}
              onChange={() => onPresetClick(preset)}
              className="sr-only"
            />
            <span
              className={`flex h-5 w-5 items-center justify-center rounded-full border
                ${
                  isSelected
                    ? 'border-blue-500'
                    : 'dark:border-dark-border-bg border-gray-400'
                }`}
            >
              {isSelected && (
                <span className="bg-primary-500 h-3 w-3 rounded-full" />
              )}
            </span>
            <span className="text-sm font-medium">{preset.label}</span>
          </label>
        );
      })}
    </div>
  );
};
